"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HomeownersBanner = void 0;
var React = _interopRequireWildcard(require("react"));
var _illustrationAdvice = _interopRequireDefault(require("./illustration-advice.svg"));
var _uiKit = require("@cian/ui-kit");
var styles = _interopRequireWildcard(require("./styles.css"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const HomeownersBanner = () => {
  return /*#__PURE__*/React.createElement("section", {
    className: styles.container
  }, /*#__PURE__*/React.createElement(_uiKit.ArticleParagraph2, {
    textAlign: "center"
  }, "\u0421\u043E\u0431\u0441\u0442\u0432\u0435\u043D\u043D\u0438\u043A\u0438 \u043C\u043E\u0433\u0443\u0442", ' ', /*#__PURE__*/React.createElement(_uiKit.UIText2, {
    fontWeight: "700",
    display: "inline"
  }, "\u0431\u0435\u0441\u043F\u043B\u0430\u0442\u043D\u043E"), ' ', "\u0440\u0430\u0437\u043C\u0435\u0441\u0442\u0438\u0442\u044C \u043F\u043E\xA0\u043E\u0434\u043D\u043E\u043C\u0443 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u044E \u0432\xA0\u043A\u0430\u0436\u0434\u043E\u0439 \u043A\u0430\u0442\u0435\u0433\u043E\u0440\u0438\u0438 \u0436\u0438\u043B\u043E\u0439 \u043D\u0435\u0434\u0432\u0438\u0436\u0438\u043C\u043E\u0441\u0442\u0438"), /*#__PURE__*/React.createElement("img", {
    width: "188px",
    height: "104px",
    src: _illustrationAdvice.default,
    loading: "lazy"
  }));
};
exports.HomeownersBanner = HomeownersBanner;